import {FlatButton} from 'material-ui';
import {Link} from 'react-router-dom';
import React from 'react';
import styled from 'styled-components';
import {HeadlineH1} from './text/Headlines';
import {NewButton} from './form/FormElements';
import {ROLE_ADMIN, ROLE_EMPLOYEE, ROLE_USER, getTranslatedRole} from '../constants/userConstants';
import BigLoadingIndicator from './BigLoadingIndicator';
import EntityTable from './table/EntityTable';
import {FileCloudDone} from 'material-ui/svg-icons';

export const isDev = () => {
  return !window.location.href.includes('//capp.hauserwirth.com');
};

let IconLock = require('../img/ic_lock.svg');

const Wrapper = styled.div`
  margin-bottom: 20px;
`;

const getTableConfig = history => ({
  maxRows: 30,
  filterString: entity => {
    return entity.name + ' ' + entity.loginName + ' ' + getTranslatedRole(entity.role);
  },
  cols: [
    {
      header: 'Name',
      valueKey: 'name',
      method: name => name,
      width: '30%',
    },
    {
      header: 'Login Name',
      valueKey: 'loginName',
      method: loginName => loginName,
      width: '20%',
    },
    {
      header: 'Rolle',
      valueKey: 'role',
      method: getTranslatedRole,
      width: '20%',
    },
    {
      header: 'Gesperrt',
      valueKey: 'active',
      method: active => !active && <img src={IconLock} alt="Benutzer gesperrt" width={15} />,
      width: '10%',
    },
    {
      header: (
        <div style={{display: 'flex', alignItems: 'center'}}>
          potentiell neu sichtbar &zwnj;
          <FileCloudDone />
        </div>
      ),
      valueKey: '*',
      method: entry =>
        entry.role !== ROLE_USER ? null : (
          <FlatButton
            style={{paddingLeft: 10, paddingRight: 10}}
            primary={true}
            label="Sammlungen"
            labelPosition="before"
            icon={entry.lastUnpublishedChangeTimestamp && <FileCloudDone />}
            onClick={e => {
              e.stopPropagation();
              history.push(`/art-collections/${entry._id}`);
            }}
          />
        ),
      width: '20%',
    },
  ],
});

function sort({name, lastUnpublishedChangeTimestamp: last}, {name: name2, lastUnpublishedChangeTimestamp: last2}) {
  if (last > last2) return -1;
  if (last < last2) return 1;
  return name - name2;
}

export default ({data: {loading, searchUsers, refetch}, createCollectionFolders, history, user}) => {
  return (
    <Wrapper>
      <HeadlineH1>Benutzer</HeadlineH1>
      {user.role === ROLE_ADMIN && (
        <div>
          <FlatButton
            onClick={() => {
              refetch({input: {role: ROLE_USER}});
              history.replace(`/users/${ROLE_USER}`);
            }}>
            Sammler
          </FlatButton>
          <FlatButton
            onClick={() => {
              refetch({input: {role: ROLE_EMPLOYEE}});
              history.replace(`/users/${ROLE_EMPLOYEE}`);
            }}>
            Angestellte
          </FlatButton>
          <FlatButton
            onClick={() => {
              refetch({input: {role: ROLE_ADMIN}});
              history.replace(`/users/${ROLE_ADMIN}`);
            }}>
            Admins
          </FlatButton>
          {isDev() && (
            <FlatButton
              onClick={async () => {
                try {
                  await createCollectionFolders();
                  alert('ordner erstellt');
                } catch (err) {
                  console.error('error on creating dirs');
                }
              }}>
              Test Ordner erstellen
            </FlatButton>
          )}
        </div>
      )}{' '}
      <NewButton>
        <Link to="/new/user">Neuer Benutzer</Link>
      </NewButton>
      <EntityTable
        tableConfig={getTableConfig(history)}
        data={loading ? [] : [...searchUsers].sort(sort)}
        msg={'Noch keine Benutzer erstellt'}
        onRowClicked={row => history.push('/logs/' + row._id)}
      />
      {loading && <BigLoadingIndicator />}
    </Wrapper>
  );
};



// WEBPACK FOOTER //
// ./src/components/Users.js